import type Dexie from "dexie";
import type { Table, TransactionMode } from "dexie";

export class BaseDexieRepository<TEntity, TKey = number> {
  protected readonly table: Table<TEntity, TKey>;
  protected readonly db: Dexie;

  constructor(table: Table<TEntity, TKey>) {
    this.table = table;
    this.db = table.db;
  }

  public get dexieTable(): Table<TEntity, TKey> {
    return this.table;
  }

  protected transaction<TResult>(
    mode: TransactionMode,
    scope: () => Promise<TResult> | TResult,
    extraTables: Array<Table<unknown, unknown, unknown>> = []
  ): Promise<TResult> {
    const primaryTable = this.table as unknown as Table<unknown, unknown, unknown>;
    const tables = [primaryTable, ...extraTables];

    type TransactionRunner = (
      transactionMode: TransactionMode,
      ...transactionArgs: Array<
        Table<unknown, unknown, unknown> | (() => Promise<TResult> | TResult)
      >
    ) => Promise<TResult>;

    const runTransaction = this.db.transaction.bind(this.db) as TransactionRunner;

    return runTransaction(mode, ...tables, scope);
  }
}
